var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="CDB-Widget-header js-header">\n  <div class="js-title"></div>\n\n  ';
 if (showSource) { ;
__p += '\n    <div class="CDB-Widget-contentSpaced CDB-Widget-contentFull">\n      <dl class="CDB-Widget-info u-tSpace">\n        <div class="u-ellipsis u-flex">\n          <span class="CDB-SelectorLayer-letter CDB-Text CDB-Size-small u-whiteTextColor u-rSpace u-upperCase" style="background-color: ' +
((__t = ( sourceColor )) == null ? '' : __t) +
';">' +
((__t = ( sourceId )) == null ? '' : __t) +
'</span>\n          <p class="CDB-Text CDB-Size-small u-secondaryTextColor u-ellipsis u-flex">\n            ' +
((__t = ( sourceType )) == null ? '' : __t) +
' <span class="u-altTextColor u-lSpace u-ellipsis" title="' +
((__t = ( layerName )) == null ? '' : __t) +
'">' +
((__t = ( layerName )) == null ? '' : __t) +
'</span>\n          </p>\n        </div>\n      </dl>\n    </div>\n  ';
 } ;
__p += '\n</div>\n\n<div class="CDB-Widget-content CDB-Widget-content--timeSeries js-content"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/cartodb-deep-insights.js/src/widgets/time-series/content.tpl
// module id = 901
// module chunks = 2 3